import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Suppliers, SupplierPalletSurcharge, SupplierPalletSurchargeInputModel } from '../../models';
import { HttpClient } from '@angular/common/http';
import { CreateSupplierRequest, PaginationSupplierRequest, SupplierSurchargesUpdate } from '../supplier';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { requestQuery } from '../../../@shared/untils';

@Injectable()
export class SupplierService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
        ) {}
    public getSuppliers(request: PaginationSupplierRequest, disableSpinner?: boolean): Observable<PaginationResponse<Suppliers>> {
        if(!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.get<PaginationResponse<Suppliers>>(`${API.SUPPLIER.GET_SUPPLIERS}?${requestQuery(request)}`)
            .pipe(tap(() => this._spinner.hide()));
    }
  public getSuppliersForLookup(search: string): Observable<Suppliers[]> {

    return this._http.get<Suppliers[]>(`${API.SUPPLIER.GET_SUPPLIERS_FOR_LOOKUP(search)}`);

  }    public getUserSuppliers(customerId: string, disableSpinner?: boolean): Observable<Suppliers[]> {
        if(!disableSpinner) {
            this._spinner.show(true);
        }
       return this._http.get<Suppliers[]>(`${API.SUPPLIER.GET_USER_SUPPLIERS(customerId)}`)
       .pipe(tap(() => this._spinner.hide()));
    }

  public getCustomerSuppliers(customerId: string): Observable<Suppliers[]> {
    return this._http.get<Suppliers[]>(`${API.SUPPLIER.GET_CUSTOMER_SUPPLIERS(customerId)}`);
      
  }
    public createOrUpdatePalletSurcharge(model: SupplierPalletSurchargeInputModel): Observable<any> {
        return this._http.put(API.SUPPLIER.CREATE_OR_UPDATE_PALLET_SURCHARGE, model).pipe(
            tap(() => {
                this._toastr.successCode(SUCCESS.UPDATE_SUPPLIER);
            }));
    }

    public create(model: CreateSupplierRequest) {
        return this._http.post(`${API.SUPPLIER.CREATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_SUPPLIER);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateSubmit(model: CreateSupplierRequest, id: string) {
        return this._http.put(API.SUPPLIER.UPDATE(id), model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_SUPPLIER);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public update(model: CreateSupplierRequest, id: string) {
        return this._http.put(API.SUPPLIER.UPDATE(id), model);
    }
    public delete(id:string) {
        return this._http.delete(API.SUPPLIER.DELETE(id))
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.DELETE_SUPPLIER);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    public getAllBoxRate(request: string): Observable<any> {
        this._spinner.show(true);
        return this._http.get<any>(`${API.SUPPLIER.GET_ALL_BOX_RATE}?supplierCostID=${request}`) .pipe(tap(() => this._spinner.hide()));
    }
    public getAllAvailableServiceConsignment(request: string): Observable<any> {
        this._spinner.show(true);
        return this._http.get<any>(`${API.SUPPLIER.GET_ALL_AVAILABLE_SERVICE_CONSIGNMENT}?supplierCostID=${request}`).pipe(tap(() => this._spinner.hide()));
    }
    public getAllSupplerSurcharge(request: string): Observable<any> {
        return this._http.get<any>(`${API.SUPPLIER.GET_ALL_SUPPLIER_SURCHARGE}?supplierID=${request}`).pipe(tap(() => this._spinner.hide()));
    }

    public getPalletSurchages(supplierId: string): Observable<SupplierPalletSurcharge[]> {
        this._spinner.show(true);
        return this._http.get<SupplierPalletSurcharge[]>(API.SUPPLIER.GET_PALLET_SURCHARGE(supplierId)) .pipe(tap(() => this._spinner.hide()));
    }
    public updateSupplierSurcharge(model: SupplierSurchargesUpdate) {
        return this._http.put(`${API.SUPPLIER.UPDATE_SUPPLIER_SURCHARGES}`, model)
        .pipe(
            tap(() => {
                this._toastr.successCode(SUCCESS.UPDATE_SUPPLIER);
            }),
            catchError((err: ErrorResponse) => {
                this._toastr.errors(err.error.errors);
                throw err;
            })
        );
    }
    public updateBoxRates(model: any) {
        return this._http.put(`${API.SUPPLIER.UPDATE_BOX_RATES}`, model)
        .pipe(
            tap(() => {
                this._toastr.successCode(SUCCESS.UPDATE_SUPPLIER);
            }),
            catchError((err: ErrorResponse) => {
                this._toastr.errors(err.error.errors);
                throw err;
            })
        );;
    }
    public updateConsignments(model: any) {
        return this._http.put(`${API.SUPPLIER.UPDATE_CONSIGNMENTS}`, model)
        .pipe(
            tap(() => {
                this._toastr.successCode(SUCCESS.UPDATE_SUPPLIER);
            }),
            catchError((err: ErrorResponse) => {
                this._toastr.errors(err.error.errors);
                throw err;
            })
        );;
    }

    public getAllPallet(strSupplier: string){
        this._spinner.show(true);
        return this._http.get(`${API.SUPPLIER.GET_ALL_PALLET(strSupplier)}`)
        .pipe(
            tap(() => {
                // this._toastr.successCode(SUCCESS.UPDATE_SUPPLIER);
                this._spinner.hide()
            }),
            catchError((err: ErrorResponse) => {
                this._toastr.errors(err.error.errors);
                this._spinner.hide()
                throw err;
            })
        );;
    }

    public updatePallets(model){
        return this._http.put(`${API.SUPPLIER.UPDATE_PALLET}`, model)
        .pipe(
            tap(() => {
                this._toastr.successCode(SUCCESS.UPDATE_PALLET);
            }),
            catchError((err: ErrorResponse) => {
                this._toastr.errors(err.error.errors);
                throw err;
            })
        );;
    }
}
